import { fetcher } from "helpers/fetcher";

import {
  TGetBUEmployeeMemberFilterReq,
  TGetBUEmployeeMemberFilterRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUEmployeeMemberFilter = async (
  params?: TGetBUEmployeeMemberFilterReq,
  language?: string
) => {
  return await fetcher<
    TGetBUEmployeeMemberFilterRes,
    TGetBUEmployeeMemberFilterReq
  >(ENDPOINT.BU.GET_BU_EMPLOYEE_MEMBER_FILTER, {
    params: params?.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_EMPLOYEE_MEMBER_FILTER.version,
      [API_HEADER.BU_ID]: params?.idBu,
      [API_HEADER.LANGUAGE]: language,
    },
  });
};

export const queryGetBUEmployeeMemberFilter = async (
  params?: TGetBUEmployeeMemberFilterReq,
  language?: string
) => {
  return (await getBUEmployeeMemberFilter(params, language)).data;
};

queryGetBUEmployeeMemberFilter._key = (
  params?: TGetBUEmployeeMemberFilterReq,
  language?: string
) => [ENDPOINT.BU.GET_BU_EMPLOYEE_MEMBER_FILTER.url, params, language];
